import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { StripeIdentityDocumentStatus } from './stripe.identity.document.entity';

export enum IdType {
    BrCpf = 'br_cpf',
    SgNric = 'sg_nric',
    UsSsn = 'us_ssn',
}

export const StripeIdentityIdNumberSchema = z
    .object({
        dob: z.date().optional(),
        firstName: z.string().optional(),
        idNumber: z.string().optional(),
        type: z.string().optional(),
        lastName: z.string().optional(),
        status: EnumSchema(StripeIdentityDocumentStatus).optional(),
    })
    .strict();

export class StripeIdentityIdNumber extends FromSchema(StripeIdentityIdNumberSchema) {
    dob?: Date;
    firstName?: string;
    idNumber?: string;
    type?: IdType;
    lastName?: string;
    status?: StripeIdentityDocumentStatus;
}
